import cli from "./cli";
import { getActiveProfile } from "./auth/profiles";
import { buildGroupedHelp } from "./lib/grouped-help";
import { colorizeOutput, shouldColorize } from "./lib/colorize-output";
import { scheduleUpdateNotice } from "./lib/update/check";
import { promptForMissingParams } from "./journey/missing-params";
import pkg from "../package.json" with { type: "json" };

const argv = process.argv.slice(2);
const activeProfile = getActiveProfile();
scheduleUpdateNotice(argv, pkg.version);

async function serve(argv: string[]) {
	if (shouldColorize(argv)) {
		await cli.serve(argv, {
			stdout: (s) => process.stdout.write(colorizeOutput(s)),
		});
	} else {
		await cli.serve(argv);
	}
}

if (
	argv.length === 0 &&
	!process.env.WHOP_API_KEY &&
	(!activeProfile || !activeProfile.accountId)
) {
	await serve(["quickstart"]);
} else if (argv.length === 0 || (argv.length === 1 && argv[0] === "--help")) {
	process.stdout.write(
		buildGroupedHelp(
			pkg.version,
			cli.description ?? "Build and manage Whop apps from your terminal.",
		) + "\n",
	);
	process.exit(0);
} else {
	await serve(await promptForMissingParams(argv));
}
